export default __webpack_public_path__ + "static/media/no-mosquitos.5d8e990f.png";